import Empty from '@components/Empty';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const NoStudies: FC = () => {
  const { t } = useTranslation('studies');

  return <Empty body={t('no_studies_p')} title={t('no_studies')} />;
};

export default NoStudies;
